import React from 'react';

import { Spacing } from '@crm-framework/spacing';
import { Loader } from '@crm-framework/loader';

import { INotificationEmptyStateProps } from './types';
import {
  EmptyStateContent,
  EmptyStateIcon,
  EmptyStateHeader,
  EmptyStateDescription,
} from './styles';

export const NotificationEmptyState: React.FC<INotificationEmptyStateProps> =
  React.memo(({ isLoading }) => (
    <Spacing pt={50}>
      {isLoading ? (
        <Loader />
      ) : (
        <EmptyStateContent>
          <EmptyStateIcon size={100} />
          <EmptyStateHeader>
            No notifications of selected type right now
          </EmptyStateHeader>
          <EmptyStateDescription>
            You can come back later or look for other types of notifications
          </EmptyStateDescription>
        </EmptyStateContent>
      )}
    </Spacing>
  ));
